// @flow

export const statuses = Object.freeze({
  All: 'All',
  WaitingForIssuance: 'WaitingForIssuance', // Ожидает выдачи
  WaitingForSpend: 'WaitingForSpend', // Ожидает проведения
  Spent: 'Spent', // Проведена
  OpenedRequest: 'OpenedRequest', // Открытая заявка
  WaitingForProcessing: 'WaitingForProcessing', // Ожидает обработки
  Removed: 'Removed', // Удалена
});

export type Status = $Values<typeof statuses>

export const toStatus = (s: string): Status => (
  statuses[s]
    ? ((s: any): Status)
    : statuses.All
);
